<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	export default {
		onLaunch: function() {
			console.log('App Launch')
		},
		onShow: async function() {},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	@import "@/uni_modules/uview-ui/index.scss";
	/*每个页面公共css */
	.red{
		color: $mini-text-color-red !important;
	}
	.green{
		color: $mini-text-color-green !important;
	}
	uni-page-head { display: none; } 
</style>